import React, { useCallback, useEffect, useState } from 'react';

type UseInfiniteScrollProps = {
  threshold?: number;
  hasMore: boolean;
  setPage: React.Dispatch<React.SetStateAction<number>>;
};

const useInfiniteScroll = ({ threshold = 0.7, setPage, hasMore }: UseInfiniteScrollProps) => {
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const handleScroll = useCallback(() => {
    if (typeof window === 'undefined') return;
    if (!hasMore) return;
    const scrollPosition = window.innerHeight + document.documentElement.scrollTop;
    const thresholdHeight = document.documentElement.scrollHeight * threshold;
    if (isFetching || scrollPosition < thresholdHeight) return;
    setIsFetching(true);
    setPage((prevPage: number) => prevPage + 1);
  }, [isFetching, setPage, threshold, hasMore]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const doneFetching = useCallback(() => {
    setIsFetching(false);
  }, []);

  return { isFetching, doneFetching };
};

export default useInfiniteScroll;
